import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  CanActivateChild,
  UrlTree
} from '@angular/router';
import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { Observable } from 'rxjs';
import { PermissionsService } from '../api/permissions/permissions.service';

@Injectable()
export class AuthPagesGuardService implements CanActivateChild {

  constructor(private authService: AuthService, private router: Router, private permissionService: PermissionsService) {
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot):
    Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    // // Se verifica si es que como paciente ya completo su ficha medica.
    // // Si aun no, se le redirecciona a dashboard siempre
    if (
      childRoute.url[0]?.path !== undefined &&
      childRoute.url[0]?.path !== "dashboard" &&
      childRoute.parent.url[0]?.path !== undefined &&
      childRoute.parent.url[0]?.path !== "dashboard" &&
      ((this.authService.panelType === "patient" &&
        !this.authService.isAfterToday(
          this.authService.user.patient?.medical_records_completed_require_after
        ) &&
        (!this.authService.user.patient?.medical_records_completed ||
          !this.authService.user.facial_recognition_added)) /*||
        (this.authService.panelType === "doctor" &&
          !this.authService.user.facial_recognition_added)*/
      )
    ) {
      return this.router.createUrlTree(["/app/dashboard"]);
    }

    return this.permissionService.routePermissions(childRoute, state) || this.router.createUrlTree(['/app/forbidden']);
  }
}
